// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@eisinc/App/SharedStyles/CartLineSharedStyles";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Icon from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";
import React, { FC } from "react";

export interface CertificationBadgesProps {
    hasEisCertification?: boolean;
    hasMfrCertification?: boolean;
}

export const EisCertBadge: FC = () => {
    return (
        <StyledWrapper {...cartLineSharedStyles.eisBadge}>
            <Icon src={Check} size={12} />
            {translate("EIS Cert.")}
        </StyledWrapper>
    );
};

export const MfrCertBadge: FC = () => {
    return (
        <StyledWrapper {...cartLineSharedStyles.mfrBadge}>
            <Icon src={Check} size={12} />
            {translate("MFR Cert.")}
        </StyledWrapper>
    );
};

export const CertificationBadges: FC<CertificationBadgesProps> = ({
    hasEisCertification = false,
    hasMfrCertification = false,
}) => {
    const showBadges = hasEisCertification || hasMfrCertification;

    if (!showBadges) {
        return null;
    }

    return (
        <StyledWrapper {...cartLineSharedStyles.certBadgesWrapper}>
            {hasEisCertification && <EisCertBadge />}
            {hasMfrCertification && <MfrCertBadge />}
        </StyledWrapper>
    );
};

export default CertificationBadges;
